import { FeatureToggle } from '@/utils/constants/featuresFlag'
import { z } from 'zod'

// Can be used to enable features in development
export const isDev = () => {
  return import.meta.env.MODE === 'development'
}

// Can be used to enable different behaviors on code during development for debugging purpose
// Activated via query-string (?debug=true)
export const isDebug = () => {
  const hasDebugParam = new URLSearchParams(window.location.search).get('debug') === 'true'
  return isDev() && hasDebugParam
}

// Returns true when running the System Under Test
// Can be used to disable features and change behaviors
export const isSUT = () => {
  return ['test', 'sut', 'e2e'].includes(import.meta.env.MODE)
}

// MARK: - Env variables validator

const EnvRequired = z.string()

const EnvFeatureToggle = z
  .string()
  .optional()
  .transform((value, ctx) => {
    if (!isSUT() && isDev() && [undefined, null, ''].includes(value)) {
      console.warn(`[FeatureToggle] ${ctx.path} not set, will assume "Disabled"`)
    }

    return !!value
  })

z.object({
  VITE_API_URL: EnvRequired,
  VITE_COUNTRIES: EnvRequired,
  // Feature toggles (optional env variables, will assume `false` when not set)
  [FeatureToggle.countryHeader]: EnvFeatureToggle,
  [FeatureToggle.userRole]: EnvFeatureToggle,
}).parse(import.meta.env)
